import type { ToastMark } from "./toastmark";

const cheapTextSearch = (parser: ToastMark, regex: RegExp): { match: string; line: string }[] => {
  const matches: { match: string; line: string }[] = [];

  parser.lineTexts.forEach((line) => {
    const match = line.match(regex);
    if (match) {
      matches.push({ match: match[0], line });
    }
  });
  return matches;
};

export { cheapTextSearch };
